import * as React from 'react';

function useDirection(t,n){const[r,o]=React.useState("ltr"),[i,u]=React.useState(),c=React.useRef(0);return React.useEffect((()=>{if(void 0===n&&null!=t&&t.parentElement){const e=getComputedStyle(t.parentElement);u(e);}}),[t,n]),React.useEffect((()=>(void 0===n&&function e(){c.current=requestAnimationFrame((()=>{const t=null==i?void 0:i.direction;t&&o(t),e();}));}(),()=>cancelAnimationFrame(c.current))),[i,n,o]),n||r}

export { useDirection };
